import React, { useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import { environment } from '../environment/production';

function ResetPassword() {
    const navigate = useNavigate();
    const location = useLocation()
    const queryParameters = new URLSearchParams(location.search)
    const [formdata,setFormData]=useState({
        token:'',
        new_password:'',
    })
    const [errormsg,setErrorMsg]=useState({
        wrongPass:'',
        new_password:'',
        new_cpassword:''
    })
    
    function handleValidations(e){
        if(e.target.new_password.value==""){
            
            setErrorMsg({...errormsg,new_cpassword:"",new_password:"Password cannot be blank"})
        }else if(e.target.new_cpassword.value==""){
            
            setErrorMsg({...errormsg,new_password:"",new_cpassword:"Confirm Password can not be blank"})
        }else{
            if(e.target.new_password.value == e.target.new_cpassword.value){
                
                setErrorMsg({...errormsg,wrongPass:"",new_password:"",new_cpassword:""})
                
                axios.post(environment.apiUrl+"/UserMng/resetPassword",JSON.stringify(formdata))
                .then((resp)=>{
                  
                   if(resp['data']['status']==1){
                    alert(resp['data']['msg'])
                    navigate("/")
                   }else{
                    alert(resp['data']['msg'])
                   }
                   
                })
            }else{
                setErrorMsg({...errormsg,wrongPass:"New Password and Confirm Password are Not Matching",new_password:"",new_cpassword:""})
            }
            
        }
       
    }
    const ResetPassword=(e)=>{
        let token=(queryParameters.get("token"))
        e.preventDefault();
        formdata.new_password=e.target.new_password.value;
        formdata.token=token
        setFormData(...[formdata])
        handleValidations(e)
    }
  return (
    <>
     <div className="login-page login-page9">   {/* style={{ backgroundImage: `url('./gstn.png')` }} */}
     <div className="login-page9-wrapper">
    
      <form onSubmit={(e)=>ResetPassword(e)}>
     
          <header> 
            <h4 className="text-center">Kindly create new password</h4>
          </header>
          
          <br/>
          <div style={{color:'red',textAlign:'center'}}>{errormsg.new_password || ''}</div> 
          <div style={{color:'red',textAlign:'center'}}>{errormsg.new_cpassword || ''}</div> 
          <div style={{color:'red',textAlign:'center'}}>{errormsg.wrongPass || ''}</div> 
          <label className="rlp-password">
            <input type="password" placeholder="Enter New Password" index="1" name="new_password" />
          </label>
          <label className="rlp-cpassword">
            <input type="password" placeholder="Confirm Password" index="1" name="new_cpassword" />
          </label>
          <section>
          <button type="submit">Reset Password</button></section>
         
      </form>
    </div>
    </div>
    </>
  )
}

export default ResetPassword